import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function Protected({ children, requireApproved = true, roles = null }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-[70vh] flex items-center justify-center font-mono text-white/50 text-xs uppercase tracking-widest">
        Establishing secure channel...
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (requireApproved && user.status !== "approved") return <Navigate to="/pending" replace />;
  if (roles && !user.is_super_admin && !roles.includes(user.role)) return <Navigate to="/portal" replace />;
  return children;
}
